import { render, staticRenderFns } from "./curveDetail.vue?vue&type=template&id=02f0aae0"
import script from "./curveDetail.vue?vue&type=script&lang=js"
export * from "./curveDetail.vue?vue&type=script&lang=js"
import style0 from "./curveDetail.vue?vue&type=style&index=0&id=02f0aae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports